export default "__VITE_ASSET__BpIauTZ4__"